import styled from 'styled-components'

export const YoutubeVideoWrapper = styled.iframe`
  max-width: 97%;
  position: absolute;
  left: 0;
  right: 0;
  margin: auto;
  top: 50%;
  transform: translateY(-50%);
`

export const TextWithBackgroundImage = styled.section`
  text-align: center;
  // margin-top: 4.8rem;

  @media screen and (min-width: ${props => props.theme.responsive.medium}) {
    // margin-top: 6.4rem;
  }

  &:last-child {
    margin-bottom: 0 !important;
  }

  .wrapper {
    position: relative;
    padding: 5.6rem 0;
    background-size: cover;
    min-height: 27rem;
    overflow: hidden;

    section {
      margin-bottom: 0;
    }

    @media screen and (min-width: ${props => props.theme.responsive.small}) {
      padding: 8rem 0;
    }

    @media screen and (min-width: ${props => props.theme.responsive.medium}) {
      max-height: 56rem;
    }

    &.videoContent {
      padding: 0;

      @media screen and (min-width: ${props => props.theme.responsive.medium}) {
        height: 56vh;
        background-position: center center;
      }

      @media screen and (max-width: ${props => props.theme.responsive.small}) {
        background-position: top left 65%;
        background-size: 200%;
      }
      /* // Leaving here incase adjustment is needed
      @media screen and (min-width: ${props =>
    props.theme.responsive.small}) and (max-width: ${props =>
  props.theme.responsive.medium}) {
        background-position: top left 25%;
        background-size: 200%;
      } */

      .videoPoster {
        height: 100%;
        width: auto;
        display: none;

        @media screen and (min-width: ${props =>
    props.theme.responsive.medium}) {
          min-width: 100%;
          min-height: 100%;
          max-width: none;
          display: none;
        }
      }
    }
    .content {
      color: ${props => props.theme.colors.white};
      position: absolute;
      width: 100%;
      top: 50%;
      left: 50%;
      transform: translate(-50%, -50%);
      svg {
        width: 4.78rem;
        fill: ${props => props.theme.colors.white};
      }
      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        svg {
          width: 8rem;
          transition: transform 0.25s;
          cursor: pointer;
          &:hover {
            transform: scale(1.05);
          }
        }
      }

      h4 {
        display: inline-block;
        &:after {
          margin: auto;
          content: '';
          display: block;
          height: 2px;
          max-width: 12.5rem;
          background-color: ${props => props.theme.colors.white};
          @media screen and (min-width: ${props =>
    props.theme.responsive.small}) {
            max-width: 32rem;
          }
        }
      }
    }

    h4 {
      margin-bottom: 1.5rem;
    }
    p {
      margin-bottom: 2.4rem;
    }
    a {
      padding: 1.2rem 3rem;
      display: block;
      font-size: 1.4rem;

      &:after {
        top: 1.1rem;
        background-size: 100%;
      }

      @media screen and (min-width: ${props => props.theme.responsive.small}) {
        font-size: 1.6rem;
        padding: 1.7rem 1.6rem;
        display: inline-block;
        min-width: 25.6rem;
      }
    }
  }
`
